import React from 'react';
import { photos } from '../data/site';
export function About() {
  return <section id="about" className="bg-paper py-24" data-id="element-17" data-mp="2prgzb5u7ihd9">
      <div className="mx-auto grid max-w-[1240px] items-center gap-16 px-6 lg:grid-cols-2" data-id="element-18" data-mp="2ps0g2j84ezpp">
        <div className="relative" data-id="element-19" data-mp="2tsamfwztrs53">
          <div className="aspect-[5/4] w-full overflow-hidden border border-line" data-id="element-20" data-mp="2tvewhazz1i3o">
            <img src={photos.deskPair} alt="Two accountants reviewing management reports at a desk" className="h-full w-full object-cover" data-id="element-21" data-mp="2ytgfxx1b7jfo" />
          </div>
          <div className="absolute -bottom-7 right-0 border border-line bg-white px-8 py-6 shadow-[0_2px_20px_rgba(11,35,35,0.06)] sm:-right-7" data-id="element-22" data-mp="38o8b6u7f5u7a">
            <span className="block font-display text-[34px] leading-none text-green-dark" data-id="element-23" data-mp="3hiwiepwk1lyq">
              2014
            </span>
            <span className="mt-2 block font-mono text-[10px] uppercase tracking-[0.12em] text-ink-50" data-id="element-24" data-mp="3mjasedhpv5ze">
              Year founded
            </span>
          </div>
        </div>

        <div data-id="element-25" data-mp="2lsa5i3cbpodl">
          <p className="eyebrow text-green-dark" data-id="element-26" data-mp="2lssc9twm3kzr">Who We Are</p>
          <h2 className="mt-5 font-display text-[34px] font-medium leading-[1.15] tracking-[-0.01em] text-ink sm:text-[42px]" data-id="element-27" data-mp="2grmgfn7nnhm0">
            Built to innovate in how Kenyan institutions manage tax, finance &amp;
            accountability
          </h2>
          <div className="double-rule mt-7 w-24 text-ink" aria-hidden="true" data-id="element-28" data-mp="27tah8wsq3bhy" />

          <p className="mt-7 text-[16px] leading-relaxed text-ink-70" data-id="element-29" data-mp="34gf8h8l5p5bc">
            Premier Advisory Services Ltd was founded in 2014 and is headquartered
            in Westlands, Nairobi, with branch offices in Nanyuki and Nakuru. We are
            a full-spectrum advisory firm rather than a single-service shop —
            clients come to us for tax, audit, accounting, forensic work, finance
            advisory and monitoring &amp; evaluation under one relationship.
          </p>
          <p className="mt-4 text-[16px] leading-relaxed text-ink-70" data-id="element-30" data-mp="3jdy1in4va4ol">
            Our practice is built around tea factory companies, legal practices,
            corporates and SMEs, and government and NGO programmes — sectors where
            reporting discipline and defensible records matter more than speed.
          </p>

          <div className="mt-10 grid gap-8 sm:grid-cols-2" data-id="element-31" data-mp="3tgtnzu7rq8w4">
            <div data-id="element-32" data-mp="1e27s8zw2crd">
              <div className="h-[2px] w-full bg-green" aria-hidden="true" data-id="element-33" data-mp="1dkdhhwse8m3" />
              <h3 className="mt-4 font-mono text-[11px] uppercase tracking-[0.12em] text-ink" data-id="element-34" data-mp="3jkgscqsnxkyq">
                Our Vision
              </h3>
              <p className="mt-3 text-[14px] leading-relaxed text-ink-70" data-id="element-35" data-mp="3ohqh04889sli">
                To be the trusted final stop for audit, tax and finance consulting
                for institutions across East Africa.
              </p>
            </div>
            <div data-id="element-36" data-mp="18s5j1icch3jk">
              <div className="h-[2px] w-full bg-ink" aria-hidden="true" data-id="element-37" data-mp="18tqdz92kmohy" />
              <h3 className="mt-4 font-mono text-[11px] uppercase tracking-[0.12em] text-ink" data-id="element-38" data-mp="1cusj26j65uru">
                Our Mission
              </h3>
              <p className="mt-3 text-[14px] leading-relaxed text-ink-70" data-id="element-39" data-mp="2xcul1v1idtcj">
                To innovate in how our clients manage tax, finance and
                accountability — with professional due care on every engagement.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}